import { frontendURL } from 'dashboard/helper/URLHelper';

// custom (2026-08-09, Lote 2): NOTIFICAÇÕES — a caixa de avisos do operador, top-level.
//
// ⚠️ NÃO confundir com `notificationRoutes` do core (`routes/dashboard/notifications/`), que
// serve a caixa de notificações do Chatwoot. As duas coexistem no roteador: a do core segue
// viva por link direto, mas saiu do menu — o Gustavo decidiu por UMA caixa só, e esta é ela.
// O conteúdo daquela aparece DENTRO desta (o NotificationReader junta as duas fontes).
//
// Nome da rota em pt-BR (`crm_notificacoes`) para não colidir com `notifications_index` do
// upstream, que continua registrado.
export const notificacoesRoutes = [
  {
    path: frontendURL('accounts/:accountId/notificacoes'),
    name: 'crm_notificacoes',
    component: () => import('./CrmNotificacoes.vue'),
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
